export default __webpack_public_path__ + "media/images/social/yelp-fdb613c2fda1e168b2bc41763c84d10e.png";